const salidas_traslado = state => state.salidas_traslado;
const para_entrada_por_traslado = state => state.para_entrada_por_traslado;


export default {
  salidas_traslado,
  para_entrada_por_traslado,

};